// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"104":"e3c3354fd48404da3983","402":"f0588844cb32c1a18c86","498":"a25581273df6c7ca69e0","562":"055ca38ead8fd788d69a","684":"d9af01e0ef1d88a740d2","700":"9adbfea4d4b38918c653","938":"09dd76662245c61db64e"}[chunkId] + ".js";
};